import { useMutation } from '@tanstack/react-query';

import { AddInstFacebookPagesData, InstPage } from '../types';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';

export const addInstFacebookPages = (
  data: AddInstFacebookPagesData
): Promise<{ pages: InstPage[] }> => {
  return axios.post(`/meta/pages/add-facebook`, data);
};

type AddInstPagesOptions = {
  config?: MutationConfig<typeof addInstFacebookPages>;
};

export function useAddInstFacebookPages({ config = {} }: AddInstPagesOptions = {}) {
  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries(['pages']);
    },
    ...config,
    mutationFn: addInstFacebookPages,
  });
}
